import { action, decorate } from "mobx";

class CustomClipActionsStore {
  constructor(
    sportyApi,
    authStore,
    routerStore,
    confirmationDialogStore,
    myCustomClipsStore,
    allCustomClipsStore
  ) {
    this.sportyApi = sportyApi;
    this.authStore = authStore;
    this.routerStore = routerStore;
    this.confirmationDialogStore = confirmationDialogStore;
    this.myCustomClipsStore = myCustomClipsStore;
    this.allCustomClipsStore = allCustomClipsStore;
  }

  editCustomClip(clip) {
    let clipUrl = `/custom-clips?gamePk=${clip.gamePk}&startTime=${clip.startTime}&endTime=${clip.endTime}&feed=${clip.feedType}`;
    if (clip.assetName) {
      clipUrl = clipUrl.concat(`&assetName=${clip.assetName}`);
    }

    this.routerStore.history.push(clipUrl);
  }

  deleteCustomClip(clip) {
    this.confirmationDialogStore.open(
      "Are you sure you want to delete this custom clip?",
      [],
      () =>
        this.sportyApi.deleteUserCustomClip(clip.id).then(() => {
          this.myCustomClipsStore.refreshClips();
          this.allCustomClipsStore.refreshClips();
        }),
      "Successfully deleted clip",
      "Failed to delete clip"
    );
  }

  canDeleteCustomClip(clip) {
    return (
      clip && this.authStore.user && this.authStore.user.sub === clip.userId
    );
  }
}

decorate(CustomClipActionsStore, {
  editCustomClip: action,
  deleteCustomClip: action,
  canDeleteCustomClip: action
});

export default CustomClipActionsStore;



// WEBPACK FOOTER //
// ./src/stores/customClips/CustomClipActionsStore.js